import { Stack, Box, Typography } from "@mui/material";

import React from "react";
import { POBSummaryType } from "../../../../../domain/models/daily-pob-report/type-wise-count-pob-summary";

type props = {
  pobSummary: POBSummaryType | null;
};

const DataSummaryPOB: React.FC<props> = ({ pobSummary }) => {
  return (
    <>
        {pobSummary && (
          <Stack
            direction={"row"}
            paddingY={3}
            borderRadius={"20px"}
            maxWidth={"75%"}
            justifyContent={"space-around"}
            bgcolor={"#f9fafd"}
            marginX={"12%"}
          >
            <Stack marginX={3}>
              <Typography variant="body2">Total TSOs</Typography>
              <Typography color="primary.main" fontWeight={600} variant="h6">
                {pobSummary.total_tso}
              </Typography>
              <Typography variant="body2" fontWeight={550}>
                Coverage: {pobSummary.tso_coverage}%
              </Typography>
            </Stack>
            <Box borderRight="2px solid #e1e3e2" />
            <Stack marginX={3}>
              <Typography variant="body2">Total Customers</Typography>
              <Typography color="primary.main" fontWeight={600} variant="h6">
                {pobSummary.total_customers}
              </Typography>
              <Typography variant="body2" fontWeight={550}>
                bricks: {pobSummary.brick_count}
              </Typography>
            </Stack>
            <Box borderRight="2px solid #e1e3e2" />
            <Stack marginX={3}>
              <Typography variant="body2"> Sales Performance</Typography>
              <Typography color="primary.main" fontWeight={600} variant="h6">
                {pobSummary.performance}%
              </Typography>
              <Typography variant="body2" fontWeight={550}>
                Growth: {pobSummary.performance_growth}%
              </Typography>
            </Stack>
            <Box borderRight="2px solid #e1e3e2" />
            <Stack marginX={3}>
              <Typography variant="body2">POB</Typography>
              <Typography color="primary.main" fontWeight={600} variant="h6">
                {pobSummary.total_pob !== null
                  ? `${(pobSummary.total_pob / 1000).toFixed(2)}K`
                  : "-"}
              </Typography>
              <Typography variant="body2" fontWeight={550}>
                Growth: {pobSummary.total_pob_growth}%
              </Typography>
            </Stack>
          </Stack>
        )}
    </>
  );
};

export default DataSummaryPOB;
